export default __webpack_public_path__ + "static/media/benner_juez.86276e46.png";